import { Application, ApplicationAnswers, ApplicationConfig } from '@bybeam/platform-types';
import { isSectionComplete } from '@platform-ui/application/hooks/useApplicationProgress.js';
import { getApplicantSections } from '@platform-ui/utilities/application/config.js';
import { getSectionRoute } from '@platform-ui/utilities/application/section.js';
import { matchPath } from 'react-router';
import { Step } from './useProgress.js';

export function buildApplicationSteps(
  config: ApplicationConfig,
  answers: Partial<ApplicationAnswers>,
  application: Application,
): Step[] {
  return getApplicantSections(config).map((section) => ({
    displayName: section.name,
    isComplete: isSectionComplete(section, answers, application),
    key: section.key,
    route: getSectionRoute(section, answers),
  }));
}

export function getCompletedSteps(steps: Step[], stepIndex: number): Step[] {
  return steps.map((step, index) => ({
    ...step,
    isComplete: index < stepIndex,
  }));
}

export function getStepIndexFromRoute(route: string, steps: Step[] = []): number {
  return steps.findIndex((step) => matchPath(route, step.route));
}

export function getProgressPercentage(steps: Step[], stepIndex: number): number {
  return stepIndex / steps.length;
}
